import React from "react";
import ReactDOM from "react-dom";
//import "./styles/base.scss";
import App from "./App";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
